import {Component, OnInit} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {faExclamationTriangle} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-drag-drop-alert-modal',
  templateUrl: './drag-drop-alert-modal.component.html',
  styleUrls: ['./drag-drop-alert-modal.component.scss']
})
export class DragDropAlertModalComponent implements OnInit {

  faExclamationTriangle = faExclamationTriangle;


  constructor(private matDialog: MatDialog) {
  }

  ngOnInit() {
  }

  cancelDragDrop() {
    this.matDialog.closeAll();
  }
}
